/** 登录页（S04）：邮箱验证码登录，附带匿名登录开发逃生口。 */

import { Button, Card, Form, Input, message, Space, Typography } from "antd";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function LoginPage() {
  const { sendEmailCode, verifyEmailCode, signInAnonymouslyDev } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? "/projects";

  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const startCountdown = () => {
    setCountdown(60);
    const t = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) clearInterval(t);
        return c - 1;
      });
    }, 1000);
  };

  const onSend = async () => {
    if (!email) return void message.warning("请输入邮箱");
    setSending(true);
    try {
      await sendEmailCode(email);
      message.success("验证码已发送，请查收邮箱");
      startCountdown();
    } catch (e) {
      message.error(`发送失败：${(e as Error).message}`);
    } finally {
      setSending(false);
    }
  };

  const onVerify = async () => {
    if (!code) return void message.warning("请输入验证码");
    setVerifying(true);
    try {
      await verifyEmailCode(email, code);
      message.success("登录成功");
      navigate(from, { replace: true });
    } catch (e) {
      message.error(`登录失败：${(e as Error).message}`);
    } finally {
      setVerifying(false);
    }
  };

  const onAnonymous = async () => {
    try {
      await signInAnonymouslyDev();
      message.success("匿名登录成功（开发模式）");
      navigate(from, { replace: true });
    } catch (e) {
      message.error(
        `匿名登录失败（新环境默认未开启匿名登录，请到控制台身份认证中开启）：${(e as Error).message}`
      );
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#f5f6f8",
      }}
    >
      <Card style={{ width: 400 }}>
        <Typography.Title level={4} style={{ textAlign: "center" }}>
          ATC 机器人平台
        </Typography.Title>
        <Typography.Paragraph type="secondary" style={{ textAlign: "center" }}>
          邮箱验证码登录
        </Typography.Paragraph>
        <Form layout="vertical">
          <Form.Item label="邮箱">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button onClick={onSend} loading={sending} disabled={countdown > 0}>
                {countdown > 0 ? `${countdown}s` : "获取验证码"}
              </Button>
            </Space.Compact>
          </Form.Item>
          <Form.Item label="验证码">
            <Input
              placeholder="6 位验证码"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              onPressEnter={onVerify}
            />
          </Form.Item>
          <Button type="primary" block onClick={onVerify} loading={verifying}>
            登录
          </Button>
        </Form>
        <div style={{ textAlign: "center", marginTop: 16 }}>
          <Typography.Link onClick={onAnonymous} type="secondary">
            匿名登录（开发模式，控制台需开启）
          </Typography.Link>
        </div>
      </Card>
    </div>
  );
}
